module.exports = __webpack_public_path__ + "img/voice_call_established.9fc3d1b5.png";